import { Box, EmptyCell, ItemsWithCount, Status, Typography } from 'shared/ui'
import { type IColumn } from 'shared/ui/TableNew'
import { type ITenDLCStatus } from 'entities/Compliance/ui/TenDLCStatus'
import { SubscriptionStatus } from 'entities/Subscription'
import { type RowClient } from 'entities/Clients/model/RowClient'
import { tenDLCClientConfig } from 'entities/Compliance/ui/TenDLCStatus/config'
import styles from './styles.module.scss'

export const activeClientsColumns: IColumn<RowClient>[] = [
  {
    field: 'client',
    name: 'Client',
    isSortable: true,
    sortKey: 'name',
    width: '196px',
    isDisabledChangeVisible: true,
    renderRowCell: (row) => ClientCell(row.clientName),
  },
  {
    field: 'email',
    name: 'Email',
    isSortable: true,
    sortKey: 'email',
    maxWidth: '290px',
    isDisabledChangeVisible: true,
    renderRowCell: (row) => ClientCell(row.email),
  },
  {
    field: 'plan_type',
    name: 'Plan type',
    maxWidth: '220px',
    isDisabledChangeVisible: true,
    renderRowCell: (row) => (row.planType ? ClientCell(row.planType) : <EmptyCell />),
  },
  {
    field: 'brand_status',
    name: '10 DLC Brand',
    maxWidth: '160px',
    renderRowCell: (row) => <TenDLCStatusCell status={row.brandStatus} />,
  },
  {
    field: 'campaign_status',
    name: '10 DLC Campaign',
    maxWidth: '180px',
    renderRowCell: (row) => <TenDLCStatusCell status={row.campaignStatus} />,
  },
  {
    field: 'subscription',
    name: 'Subscription',
    maxWidth: '160px',
    renderRowCell: (row) => {
      const status = row.subscriptionStatus
      return <SubscriptionStatus status={status} />
    },
  },
  {
    field: 'credits',
    name: 'Credits',
    maxWidth: '120px',
    renderRowCell: (row) => row.credits.toLocaleString(),
  },
  {
    field: 'groups',
    name: 'Hubspot team',
    renderRowCell: (row) => {
      if (!row.groups.length) {
        return <EmptyCell />
      }

      return (
        <ItemsWithCount
          items={row.groups}
          className={styles.groupsContainer}
          itemComponent={({ item }) => (
            <div className={styles.groupItem}>
              <Typography
                variant={'body-md-regular'}
                ellipsis
                ariaLabel={'ClientGroupName'}
                tooltipProps={{ label: item.name }}
              >
                {item.name}
              </Typography>
            </div>
          )}
          containerWidth={210}
          width={210}
          cacheScope={'client-groups'}
          dropdownItemRenderer={(item) => ({
            id: item.id,
            label: item.name,
            labelContent: (
              <Box display='flex'>
                <Typography
                  variant={'body-md-regular'}
                  ellipsis
                  ariaLabel='ClientGroupNameDropdown'
                  tooltipProps={{ label: item.name, placement: 'left', fullWidth: true }}
                >
                  {item.name}
                </Typography>
              </Box>
            ),
          })}
        />
      )
    },
  },
]

const ClientCell = (value: string) => {
  return value ? (
    <Box display='flex'>
      <Typography
        variant={'body-md-regular'}
        ellipsis
        ariaLabel={`ClientCell_${value}`}
        tooltipProps={{
          label: value,
        }}
      >
        {value}
      </Typography>
    </Box>
  ) : (
    <EmptyCell />
  )
}

const TenDLCStatusCell = ({ status }: { status: ITenDLCStatus }) => {
  return status ? <Status {...tenDLCClientConfig[status]} /> : <EmptyCell />
}
